import { Box } from 'reflexbox';

import { NotesDetailContainerWithoutSidebar } from 'notes/NotesDetailContainer';
import { Button, Toolbar, Container, Callout } from '@treams/treams-ui';
import { ArchiveIcon, ChevronLeftIcon, UndoIcon } from '@treams/treams-icons';
import { useTranslation } from 'react-i18next';

import * as graphql from 'generated/graphql';
import { ModalContext } from 'navigation/ModalNavigation';

export default function Note(props: { id: string; userID?: string }) {
	const { t } = useTranslation();

	const [archive, { loading: isLoadingArchive }] = graphql.useArchiveNoteMutation();
	const [restore, { loading: isLoadingRestore }] = graphql.useRestoreNoteMutation();

	const note = graphql.useNoteQuery({ variables: { id: props.id } });

	const isArchived = note.data?.note.isArchived;

	const onArchiveRestore = async () => {
		if (isArchived) {
			await restore({ variables: { input: { noteID: props.id } } });
			return;
		}
		await archive({ variables: { input: { noteID: props.id } } });
	};

	return (
		<ModalContext.Consumer>
			{({ isModal }) => (
				<Box flexGrow={1} flexShrink={1} mt={4} px={isModal ? 0 : [3, 4, 5]}>
					<Container>
						{isArchived && (
							<Callout
								mb={3}
								color="red"
								icon={<ArchiveIcon />}
								title={t('note.show.archived.title')}
								description={t('note.show.archived.description')}
							/>
						)}
						<Toolbar>
							{!isModal && (
								<Button
									icon={<ChevronLeftIcon />}
									link={props.userID ? `/users/${props.userID}/notes` : '/notes'}
									title={t('goals.show.toolbar.back')}
									type="secondary"
								/>
							)}
							<Toolbar.Spacing />
							{((isArchived && note.data?.note.viewerCanRestore) ||
								(!isArchived && note.data?.note.viewerCanArchive)) && (
								<Button
									title={
										isArchived ? t('note.show.toolbar.restore') : t('note.show.toolbar.archive')
									}
									type="destructive"
									icon={isArchived ? <UndoIcon /> : <ArchiveIcon />}
									loading={isLoadingArchive || isLoadingRestore}
									onClick={() => {
										onArchiveRestore();
									}}
								/>
							)}
						</Toolbar>
						<NotesDetailContainerWithoutSidebar id={props.id} />
					</Container>
				</Box>
			)}
		</ModalContext.Consumer>
	);
}
